import TextEditor from "../../TextEditor/TextEditor";
import Question from "../Question/Question";

const Text = (props) => {
  const { label, onChange, disabled } = props;

  return (
    <Question {...props} type="متن" noRequired noDescription noLabel>
      <div
        style={{
          width: "100%",
          height: !disabled && "15rem",
          marginBottom: !disabled && "2rem",
        }}
      >
        {!disabled && (
          <TextEditor
            value={label}
            onChange={(text) => onChange("label", text)}
          />
        )}
      </div>
    </Question>
  );
};
export default Text;
